<div class="w-full">
    <input
        class="peer absolute scale-0 hidden h-0"
        type="checkbox"
        [checked]="internalOpen"
        (change)="internalOpen = !internalOpen"
    />
    <span
        class="block max-h-[77px] w-full overflow-hidden transition-all duration-300 peer-checked:max-h-[2000px] border border-shs-gray-3 rounded-md p-1"
    >
        <div class="p-6 flex flex-col gap-6" (click)="expandable() && (internalOpen = !internalOpen)">
            <div class="flex items-center justify-between gap-4 cursor-pointer select-none">
                <div class="flex items-center gap-4">
                    <span class="text-base text-white">{{ data().serial ? 'COD#' + data().serial : 'New COD' }}</span>
                    <div class="text-xs text-white font-bold bg-[#AB02ED] px-2 py-1 rounded-md">
                        {{ data().subType.issueType }}
                    </div>
                </div>
                @if (showBackTo()) {
                <sag-ui-button color="tertiary" (click)="backToForm()">
                    <span class="icon-options-vertical"></span>
                </sag-ui-button>
                }
            </div>
            <div class="flex flex-col">
                <span class="text-sm text-font-secondary">Nature of Complaint</span>
                <span class="text-xl text-white font-bold">{{ data().natureOfComplaint }}</span>
            </div>
            <div class="flex gap-10">
                <div class="flex flex-col">
                    <span class="text-sm text-font-secondary">Reference Number</span>
                    <span class="text-base text-white">{{ data().referenceNumber }}</span>
                </div>
                <div class="flex flex-col">
                    <span class="text-sm text-font-secondary">Country</span>
                    <span class="text-base text-white">{{ data().shipToCountryCode || data().region }}</span>
                </div>
                <div class="flex flex-col">
                    <span class="text-sm text-font-secondary">Financial Adjustment</span>
                    <span class="text-base text-white">{{
                        financialAdjustmentValue() | currency : (data().region === region.NAM ? 'USD' : 'EUR')
                    }}</span>
                </div>
                @if (data().status) {
                <div class="flex flex-col">
                    <span class="text-sm text-font-secondary">Status</span>
                    <span class="text-base text-white">{{ data().status }}</span>
                </div>
                }
            </div>
            <div class="flex gap-10">
                <div class="flex flex-col">
                    <span class="text-sm text-font-secondary">Created by</span>
                    <span class="text-base text-white">{{ data().createdBy | user | async }}</span>
                </div>
                <div class="flex flex-col">
                    <span class="text-sm text-font-secondary">Created on</span>
                    <span class="text-base text-white">{{ createdAt() | date }}</span>
                </div>
                <div class="flex flex-col">
                    <span class="text-sm text-font-secondary">Order Date</span>
                    <span class="text-base text-white">{{ orderLineItem()?.soCreationDate | date }}</span>
                </div>
                <div class="flex flex-col">
                    <span class="text-sm text-font-secondary">TU</span>
                    <span class="text-base text-white">{{ orderLineItem()?.transportUnit ?? '-' }}</span>
                </div>
            </div>
            <div class="flex gap-10">
                <div class="flex flex-col">
                    <span class="text-sm text-font-secondary">Sales Order Number</span>
                    <span class="text-base text-white">{{ orderLineItem()?.salesOrderNumber ?? '-' }}</span>
                </div>
                <div class="flex flex-col">
                    <span class="text-sm text-font-secondary">Purchase Order Number</span>
                    <span class="text-base text-white">{{ orderLineItem()?.purchaseOrderReference ?? '-' }}</span>
                </div>
                <div class="flex flex-col">
                    <span class="text-sm text-font-secondary">Invoice Number</span>
                    <span class="text-base text-white">{{ orderLineItem()?.invoiceNumber ?? '-' }}</span>
                </div>
                <div class="flex flex-col">
                    <span class="text-sm text-font-secondary">Sales Organization</span>
                    <span class="text-base text-white">{{ orderLineItem()?.salesOrganisation ?? '-' }}</span>
                </div>
            </div>
            <div class="flex gap-10">
                <div class="flex flex-col">
                    <span class="text-sm text-font-secondary">Ship To Customer Number</span>
                    <span class="text-base text-white">{{ orderLineItem()?.shipToCustomerNumber ?? '-' }}</span>
                </div>
                <div class="flex flex-col">
                    <span class="text-sm text-font-secondary">Ship To Customer Name</span>
                    <span class="text-base text-white">{{ orderLineItem()?.shipToCustomerName ?? '-' }}</span>
                </div>
                <div class="flex flex-col">
                    <span class="text-sm text-font-secondary">Ship To State</span>
                    <span class="text-base text-white">{{ orderLineItem()?.shipToCountryCode ?? '-' }}</span>
                </div>
            </div>
            <div class="flex gap-10">
                <div class="flex flex-col">
                    <span class="text-sm text-font-secondary">Route</span>
                    <span class="text-base text-white">{{ orderLineItem()?.route ?? '-' }}</span>
                </div>
            </div>
            <div class="flex gap-10">
                <div class="flex flex-col">
                    <span class="text-sm text-font-secondary">Affected Items</span>
                    <div class="w-full overflow-x-auto">
                        <div class="min-w-[1080px]">
                            <div
                                class="grid grid-cols-[70px_95px_115px_80px_minmax(160px,1fr)_85px_80px_95px_85px_80px_85px] gap-1 w-full border-b border-shs-gray-4 mt-2"
                            >
                                <div class="text-font-tertiary px-1.5 py-2 text-sm truncate">Line Item</div>
                                <div class="text-font-tertiary px-1.5 py-2 text-sm truncate">SMN</div>
                                <div class="text-font-tertiary px-1.5 py-2 text-sm truncate">Delivery Number</div>
                                <div class="text-font-tertiary px-1.5 py-2 text-sm truncate">Batch</div>
                                <div class="text-font-tertiary px-1.5 py-2 text-sm truncate">Description</div>
                                <div class="text-font-tertiary px-1.5 py-2 text-sm truncate text-center">
                                    Handling Unit
                                </div>
                                <div class="text-font-tertiary px-1.5 py-2 text-sm truncate text-center">
                                    Price/Item
                                </div>
                                <div class="text-font-tertiary px-1.5 py-2 text-sm truncate text-center">
                                    Source Plant
                                </div>
                                <div class="text-font-tertiary px-1.5 py-2 text-sm truncate text-center">
                                    Source Country
                                </div>
                                <div class="text-font-tertiary px-1.5 py-2 text-sm truncate text-center">
                                    Sales Order Qty
                                </div>
                                <div class="text-font-tertiary px-1.5 py-2 text-sm truncate text-center">
                                    Affected Qty
                                </div>
                            </div>
                            @for (item of sortedOrderLines(); track $index) {
                            <div
                                class="grid grid-cols-[70px_95px_115px_80px_minmax(160px,1fr)_85px_80px_95px_85px_80px_85px] gap-1 w-full border-b border-shs-gray-4"
                            >
                                <div
                                    class="text-font-tertiary px-1.5 py-3 text-xs"
                                    sag-ui-tooltip
                                    tooltip="{{ item.salesOrderLine }}"
                                >
                                    {{ item.salesOrderLine }}
                                </div>
                                <div class="text-font-tertiary px-1.5 py-3 text-xs">
                                    {{ removeLeadingZeros(item.smn) }}
                                </div>
                                <div class="text-font-tertiary px-1.5 py-3 text-xs">
                                    {{ item.deliveryNumber }}
                                </div>
                                <div class="text-font-tertiary px-1.5 py-3 text-xs">
                                    {{ item.batch }}
                                </div>
                                <div
                                    class="text-font-tertiary px-1.5 py-3 text-xs truncate"
                                    sag-ui-tooltip
                                    tooltip="{{ item.materialDescription }}"
                                >
                                    {{ item.materialDescription }}
                                </div>
                                <div
                                    class="text-font-tertiary px-1.5 py-3 text-xs truncate text-center"
                                    sag-ui-tooltip
                                    tooltip="{{ item.handlingUnit }}"
                                >
                                    {{ item.handlingUnit }}
                                </div>
                                <div class="text-font-tertiary px-1.5 py-3 text-xs truncate text-center">
                                    {{ item.price | currency : (data().region === region.NAM ? 'USD' : 'EUR') }}
                                </div>
                                <div
                                    class="text-font-tertiary px-1.5 py-3 text-xs truncate text-center"
                                    sag-ui-tooltip
                                    tooltip="{{ item.sourcePlant }}"
                                >
                                    {{ item.sourcePlant }}
                                </div>
                                <div
                                    class="text-font-tertiary px-1.5 py-3 text-base truncate text-center"
                                    sag-ui-tooltip
                                    tooltip="{{ item.sourceCountry }}"
                                >
                                    {{ item.sourceCountry }}
                                </div>
                                <div
                                    class="text-font-tertiary px-1.5 py-3 text-base truncate text-center"
                                    sag-ui-tooltip
                                    tooltip="{{ item.salesOrderQuantity }}"
                                >
                                    {{ item.salesOrderQuantity }}
                                </div>
                                <div class="text-font-tertiary px-1.5 py-3 text-base truncate">
                                    <app-number-input
                                        [value]="item.affectedQuantity!"
                                        [max]="item.salesOrderQuantity"
                                        [readonly]="true"
                                    ></app-number-input>
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                    @if(data().id && data().assignedTo) {
                    <div class="flex gap-10 mt-4">
                        <div class="flex flex-col">
                            <span class="text-sm text-font-secondary">Assigned to</span>
                            <span class="text-base text-white">{{ data().assignedTo | user | async }}</span>
                        </div>
                    </div>
                    }
                </div>
            </div>
        </div>
    </span>
</div>
